module.exports = __webpack_public_path__ + "src/assets/games/52/bg.png";